import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { Row, Col, Alert } from "antd";

import ColliRow from "../colliRow";
import IconButton from "../../../app/generic/iconButton";
import { loadWrappings } from "../../../../modules/staticDataLoad";
import WrappingCheck from "../../../consignment/colliForm/wrappingCheck";
import ColliTableFooter from "../../../consignment/colliForm/colliTableFooter";

const Collis = ({
  adr,
  form,
  rules,
  products,
  formData,
  onSetCollis,
  validCollis,
  onSetFormData,
  onHeightChange,
  formItemLayout,
  selectedProduct,
  onSetValidCollis,
  onAnyValueChange,
  getFieldDecorator,
}) => {
  const intl = useIntl();

  const [wrappingModalVisible, setWrappingModalVisible] = useState();

  const handleAnyValueChange = useCallback(() => {
    onAnyValueChange();
    onSetFormData();
  }, [onSetFormData, onAnyValueChange]);

  const [wrappings, setWrappings] = useState();
  const handleLoadData = useCallback(() => {
    loadWrappings(setWrappings, selectedProduct && selectedProduct.id);
  }, [selectedProduct]);

  const [lastIdx, setLastIdx] = useState(1);
  const [collis, setCollis] = useState([0]);
  const handleCollisSet = useCallback(
    (newCollis) => {
      onSetCollis(newCollis);
      setCollis(newCollis);
    },
    [onSetCollis]
  );
  const handleColliDelete = useCallback(
    (idx) => {
      collis.length > 0 &&
        handleCollisSet([...collis.filter((c) => c !== idx)]);
    },
    [collis, handleCollisSet]
  );
  const handleColliAdd = useCallback(() => {
    handleCollisSet([...collis, lastIdx]);
    setLastIdx(lastIdx + 1);
    handleAnyValueChange();
  }, [lastIdx, collis, handleCollisSet, handleAnyValueChange]);

  useEffect(() => {
    handleLoadData();
  }, [intl.locale, handleLoadData]);

  const [showStackableWarn, setShowStackableWarn] = useState(false);
  const [shouldNotBeStackable, setShouldNotBeStackable] = useState(false);
  useEffect(() => {
    if (adr) {
      collis.length === 1 && setShouldNotBeStackable(true);
      collis.length > 1 && setShowStackableWarn(true);
    } else {
      setShouldNotBeStackable(false);
      setShowStackableWarn(false);
    }
  }, [adr, collis]);

  const [stackables, setStackables] = useState({ 0: false });
  const forceLoadingMeters = useMemo(
    () => Object.keys(stackables).some((k) => stackables[k]),
    [stackables]
  );

  return (
    <>
      {collis.map((idx, i) => (
        <ColliRow
          key={i}
          adr={adr}
          index={idx}
          form={form}
          rules={rules}
          products={products}
          wrappings={wrappings}
          onSetStackables={setStackables}
          onHeightChange={onHeightChange}
          formItemLayout={formItemLayout}
          onColliDelete={handleColliDelete}
          disabledDelete={collis.length === 1}
          getFieldDecorator={getFieldDecorator}
          onAnyValueChange={handleAnyValueChange}
          forceLoadingMeters={forceLoadingMeters}
          selectedProductId={selectedProduct && selectedProduct.id}
          shouldNotBeStackable={idx === 0 ? shouldNotBeStackable : false}
        />
      ))}
      <Row type="flex" justify="space-between" gutter={[0, 20]}>
        <Col>
          <ColliTableFooter
            rules={rules}
            adrCount={adr ? 1 : 0}
            onValidatonResult={onSetValidCollis}
            collis={formData && formData.collis}
            valid={formData ? validCollis : true}
            forceLoadingMeters={forceLoadingMeters}
          />
        </Col>
        <Col>
          <IconButton
            icon="plus"
            shape="none"
            onClick={handleColliAdd}
            text={
              validCollis === false
                ? ""
                : intl.formatMessage({
                    id: "calculator.addColli",
                    defaultMessage: "Přidat další kus",
                  })
            }
          />
        </Col>
        <WrappingCheck
          rules={rules}
          wrappings={wrappings}
          collis={formData?.collis}
          wrappingModalVisible={wrappingModalVisible}
          onSetWrappingModalVisible={setWrappingModalVisible}
        />
      </Row>
      {showStackableWarn && (
        <Row type="flex" gutter={[0, 20]}>
          <Col span={24}>
            <Alert
              closable
              type="warning"
              message={intl.formatMessage({
                id: "consignment.colli.stackable.warning",
                defaultMessage:
                  "Prosím určete příznakem nestohovatelnost, který z kusů je ADR.",
              })}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default Collis;
